<template>
  <div class="contentBox min-w-1400">
    <div class="flexBox bannerBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg1" alt="" class="bannerImgItem" />
      </div>
    </div>
    <div class="flexBox priBox min-w-1400" @click="toggleNewImage(1)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg1 ? qaImg_a1 : qaImg_q1" class="imgItem" />
      </div>
    </div>
    <div class="flexBox priBox min-w-1400" @click="toggleNewImage(2)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg2 ? qaImg_a2 : qaImg_q2" class="imgItem" />
      </div>
    </div>
    <div class="flexBox priBox min-w-1400" @click="toggleNewImage(3)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg3 ? qaImg_a3 : qaImg_q3" class="imgItem" />
      </div>
    </div>
    <div class="flexBox priBox min-w-1400" @click="toggleNewImage(4)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg4 ? qaImg_a4 : qaImg_q4" class="imgItem" />
      </div>
    </div>
    <div class="flexBox priBox min-w-1400" @click="toggleNewImage(5)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg5 ? qaImg_a5 : qaImg_q5" class="imgItem" />
      </div>
    </div>
    <div class="flexBox priBox min-w-1400" @click="toggleNewImage(6)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg6 ? qaImg_a6 : qaImg_q6" class="imgItem" />
      </div>
    </div>
    <div class="flexBox priBox min-w-1400" @click="toggleNewImage(7)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg7 ? qaImg_a7 : qaImg_q7" class="imgItem" />
      </div>
    </div>
    <div class="flexBox priBox min-w-1400" @click="toggleNewImage(8)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg8 ? qaImg_a8 : qaImg_q8" class="imgItem" />
      </div>
    </div>
    <div class="flexBox priBox min-w-1400" @click="toggleNewImage(9)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg9 ? qaImg_a9 : qaImg_q9" class="imgItem" />
      </div>
    </div>
    <div class="flexBox priBox min-w-1400" @click="toggleNewImage(10)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg10 ? qaImg_a10 : qaImg_q10" class="imgItem" />
      </div>
    </div>
    <div class="flexBox priBox min-w-1400" @click="toggleNewImage(11)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg11 ? qaImg_a11 : qaImg_q11" class="imgItem" />
      </div>
    </div>
    <div class="flexBox priBox min-w-1400" @click="toggleNewImage(12)">
      <div class="imgBox max-w-1400">
        <img :src="isActimg12 ? qaImg_a12 : qaImg_q12" class="imgItem" />
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/consumerbusinessloan/components/img/question1.png";
import qaImg_q1 from "@/page/consumerbusinessloan/components/img/qa_q1.png";
import qaImg_q2 from "@/page/consumerbusinessloan/components/img/qa_q2.png";
import qaImg_q3 from "@/page/consumerbusinessloan/components/img/qa_q3.png";
import qaImg_q4 from "@/page/consumerbusinessloan/components/img/qa_q4.png";
import qaImg_q5 from "@/page/consumerbusinessloan/components/img/qa_q5.png";
import qaImg_q6 from "@/page/consumerbusinessloan/components/img/qa_q6.png";
import qaImg_q7 from "@/page/consumerbusinessloan/components/img/qa_q7.png";
import qaImg_q8 from "@/page/consumerbusinessloan/components/img/qa_q8.png";
import qaImg_q9 from "@/page/consumerbusinessloan/components/img/qa_q9.png";
import qaImg_q10 from "@/page/consumerbusinessloan/components/img/qa_q10.png";
import qaImg_q11 from "@/page/consumerbusinessloan/components/img/qa_q11.png";
import qaImg_q12 from "@/page/consumerbusinessloan/components/img/qa_q12.png";


import qaImg_a1 from "@/page/consumerbusinessloan/components/img/qa_a1.png";
import qaImg_a2 from "@/page/consumerbusinessloan/components/img/qa_a2.png";
import qaImg_a3 from "@/page/consumerbusinessloan/components/img/qa_a3.png";
import qaImg_a4 from "@/page/consumerbusinessloan/components/img/qa_a4.png";
import qaImg_a5 from "@/page/consumerbusinessloan/components/img/qa_a5.png";
import qaImg_a6 from "@/page/consumerbusinessloan/components/img/qa_a6.png";
import qaImg_a7 from "@/page/consumerbusinessloan/components/img/qa_a7.png";
import qaImg_a8 from "@/page/consumerbusinessloan/components/img/qa_a8.png";
import qaImg_a9 from "@/page/consumerbusinessloan/components/img/qa_a9.png";
import qaImg_a10 from "@/page/consumerbusinessloan/components/img/qa_a10.png";
import qaImg_a11 from "@/page/consumerbusinessloan/components/img/qa_a11.png";
import qaImg_a12 from "@/page/consumerbusinessloan/components/img/qa_a12.png";


export default {
  data() {
    return {
      importedImg1,
      qaImg_q1,
      qaImg_q2,
      qaImg_q3,
      qaImg_q4,
      qaImg_q5,
      qaImg_q6,
      qaImg_q7,
      qaImg_q8,
      qaImg_q9,
      qaImg_q10,
      qaImg_q11,
      qaImg_q12,
      qaImg_a1,
      qaImg_a2,
      qaImg_a3,
      qaImg_a4,
      qaImg_a5,
      qaImg_a6,
      qaImg_a7,
      qaImg_a8,
      qaImg_a9,
      qaImg_a10,
      qaImg_a11,
      qaImg_a12,
      isActimg1: false,
      isActimg2: false,
      isActimg3: false,
      isActimg4: false,
      isActimg5: false,
      isActimg6: false,
      isActimg7: false,
      isActimg8: false,
      isActimg9: false,
      isActimg10: false,
      isActimg11: false,
      isActimg12: false,
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    toggleNewImage(imageIndex) {
      if (imageIndex == 1) {
        this.isActimg1 = !this.isActimg1;
      }
      if (imageIndex == 2) {
        this.isActimg2 = !this.isActimg2;
      }
      if (imageIndex == 3) {
        this.isActimg3 = !this.isActimg3;
      }
      if (imageIndex == 4) {
        this.isActimg4 = !this.isActimg4;
      }
      if (imageIndex == 5) {
        this.isActimg5 = !this.isActimg5;
      }
      if (imageIndex == 6) {
        this.isActimg6 = !this.isActimg6;
      }
      if (imageIndex == 7) {
        this.isActimg7 = !this.isActimg7;
      }
      if (imageIndex == 8) {
        this.isActimg8 = !this.isActimg8;
      }
      if (imageIndex == 9) {
        this.isActimg9 = !this.isActimg9;
      }
      if (imageIndex == 10) {
        this.isActimg10 = !this.isActimg10;
      }
      if (imageIndex == 11) {
        this.isActimg11 = !this.isActimg11;
      }
      if (imageIndex == 12) {
        this.isActimg12 = !this.isActimg12;
      }
    },
  },
};

</script>

<style scoped>
.contentBox {
  display: flex;
  flex-direction: column;
  background-color: #FDFFFE;
  margin-bottom: 50px;
}

.textContent{
  padding: 60px 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.title{
  color: #333333;
  font-family: "Thonburi";
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
}


.flexBox {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.imgBox{
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem {
  padding: 0px 150px;
  width: 100%;
}
.bannerImgItem{
   margin-bottom: 50px;
  width: 100%;
}


.priBox{
  cursor: pointer;
  margin-bottom: 60px;
}
</style>
